(function () {
    'use strict';
    /*
     * Copyright (c) 2016-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhViewEditDate', ihhViewEditDate);

    function ihhViewEditDate() {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                /**
                 * The HTML id to use for the control and label, for accessibility.
                 * @ngdoc property
                 * @name control-id
                 * @memberOf ihh-common-web.ihh-view-edit-text
                 */
                controlId: '@',

                /**
                 * The text to display as a label.
                 * @ngdoc property
                 * @name label
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                label: '@',

                /**
                 * If set, marks the field as required, and in edit mode displayes a visual cue that the value is required.
                 * @ngdoc property
                 * @name is-required
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                isRequired: '=',

                /**
                 * The scope variable used as the model for displaying the text in view mode.
                 * @ngdoc property
                 * @name model
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                model: '=',

                /**
                 * The scope variable used as the model for displaying the text in edit mode.
                 * @ngdoc property
                 * @name model-edit
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                modelEdit: '=',

                /**
                 * A scope variable that can be used to indicate that the model is a getter/setter, rather than a simple value.
                 */
                isModelGetterSetter: '=',

                /**
                 * The value to determine if the datepicker is open.
                 * @ngdoc property
                 * @name is-open
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                isOpen: '&',

                /**
                 * The initial date to set.
                 * @ngdoc property
                 * @name init-date
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                initDate: '@',

                /**
                 * The minimum allowable date to set.
                 * @ngdoc property
                 * @name min-date
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                minDate: '@',

                /**
                 * The maximum allowable date to set.
                 * @ngdoc property
                 * @name max-date
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                maxDate: '@',

                /**
                 * The value to determine if the page is in edit mode.
                 * @ngdoc property
                 * @name is-edit
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                isEdit: '=',

                /**
                 * The value to determine how to render the day in view mode.
                 * @ngdoc property
                 * @name display-format
                 * @memberOf ihh-common-web.ihh-view-edit-date
                 */
                displayFormat: '@',

                /**
                 * Whether to show a time control too.
                 */
                showTime: '='
            },
            templateUrl: 'view-edit/view-edit-date.tpl.html',
            controller: 'IhhViewEditDateCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();